import { render, staticRenderFns } from "./fanCollapse.vue?vue&type=template&id=20a085a8&scoped=true&"
import script from "./fanCollapse.vue?vue&type=script&lang=js&"
export * from "./fanCollapse.vue?vue&type=script&lang=js&"
import style0 from "./fanCollapse.vue?vue&type=style&index=0&id=20a085a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a085a8",
  null
  
)

export default component.exports